import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { CONTACT, waLink } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-[#1A1716] text-white/70 relative grain" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-20 grid gap-14 md:grid-cols-12">
      <div className="md:col-span-4">
        <img src="/brand/helium-logo.svg" alt="Hélium Résidences" className="w-36 h-auto" data-testid="footer-logo" />
        <p className="mt-6 text-sm leading-relaxed max-w-xs">
          Promotion immobilière, location, BTP et prestation de services au Sénégal.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow mb-5">Navigation</p>
        <ul className="space-y-3 text-sm">
          <li><Link to="/programmes" className="hover:text-white transition-colors" data-testid="footer-programmes-link">Nos programmes</Link></li>
          <li><Link to="/#services" className="hover:text-white transition-colors" data-testid="footer-services-link">Nos services</Link></li>
          <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">Contact</Link></li>
          <li><Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">Espace administrateur</Link></li>
        </ul>
      </div>
      <div className="md:col-span-5">
        <p className="eyebrow mb-5">Nous joindre</p>
        <ul className="space-y-4 text-sm">
          <li><a href={`tel:${CONTACT.tel}`} className="flex items-center gap-3 hover:text-white" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-[#C88A58]" />{CONTACT.phone}</a></li>
          <li><a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white" data-testid="footer-whatsapp-link"><MessageCircle className="h-4 w-4 text-[#C88A58]" />WhatsApp {CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white" data-testid="footer-email-link"><Mail className="h-4 w-4 text-[#C88A58]" />{CONTACT.email}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
      © {new Date().getFullYear()} Hélium Résidences — Tous droits réservés
    </div>
  </footer>
);
